/* eslint-disable import/no-cycle */
import * as React from 'react';
import * as auth from '../services/authService';
import { useAuth } from '../lib/auth-provider';

const apiURL = process.env.REACT_APP_API_URL;

export async function apiRequest(
  endpoint,
  {
    data, headers: customHeaders, ...customConfig
  } = {},
) {
  const token = auth.getAuthToken();
  const config = {
    method: data ? 'POST' : 'GET',
    body: data ? JSON.stringify(data) : undefined,
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
      'Content-Type': data ? 'application/json' : undefined,
      ...customHeaders,
    },
    ...customConfig,
  };

  return window.fetch(`${apiURL}/${endpoint}`, config).then(async (response) => {
    if (response.status === 401) {
      await auth.logout();
      window.location.assign(window.location);
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({ message: 'Please re-authenticate.' });
    }
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const data = await response.json();
    if (response.ok) {
      return data;
    }
    return Promise.reject(data);
  });
}

export function useApiRequest() {
  const { user } = useAuth();
  const token = user?.token;
  return React.useCallback(
    (endpoint, config) => apiRequest(endpoint, { ...config, token }),
    [token],
  );
}
